<template>
  <div class="one-description-read">
    <readLayout>
      <h2>
        {{ $store.getters.oneDescription.title }}
      </h2>
      <p class="date-in-title">{{ $store.getters.oneDescription.released_at }}</p>
      <div v-html="$store.getters.oneDescription.content"></div>
    </readLayout>
  </div>
</template>

<script>
import readLayout from "@/layout/ReadLayout.vue";
export default {
  name: "DescriptionRead",
  components: {
    readLayout
  }
};
</script>

<style lang="scss" scoped>
.one-description-read {
  padding: 1rem;
}
</style>
